<template>
    <svg
        width="7"
        height="7"
        viewBox="0 0 13 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2104 0.360617C10.6912 -0.120206 11.4708 -0.120206 11.9516 0.360617C12.3888 0.797729 12.4285 1.48174 12.0709
            1.96374L11.9516 2.10183L2.10183 11.9516C1.62101 12.4325 0.841441 12.4325 0.360618 11.9516C-0.0764949 11.5145
            -0.116232 10.8305 0.241406 10.3485L0.360618 10.2104L10.2104 0.360617Z"
        fill="white"
      />
      <path
        d="M0.360617 0.360618C0.797729 -0.0764949 1.48174 -0.116232 1.96374 0.241406L2.10183 0.360618L11.9516 10.2104C12.4325
            10.6912 12.4325 11.4708 11.9516 11.9516C11.5145 12.3888 10.8305 12.4285 10.3485 12.0709L10.2104 11.9516L0.360617
            2.10183C-0.120206 1.62101 -0.120206 0.841441 0.360617 0.360618Z"
        fill="white"
      />
    </svg>
</template>

<script>
export default {
  name: 'IconClose',
};
</script>
